import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromPromise';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import type FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { REFRESH_SOURCE_FAILURE } from '../../model/constants.tsx';
import {
	setParentFailure,
	setParentSuccess,
	SET_PARENT_OPTIMISTIC,
	type SetParentOptimisticAction,
} from '../../state/actions/issue/parent/index.tsx';
import { workRefreshData } from '../../state/actions/work/index.tsx';
import type { Action, ActionsObservable, MiddlewareAPI } from '../../state/types.tsx';
import { getIsCMPBoard } from '../../state/selectors/software/software-selectors.tsx';
import { publishInlineEditingEvent } from '../../common/hooks/use-inline-editing-pub-sub/index.tsx';
import { InlineEditingEventTypes } from '../../common/hooks/use-inline-editing-pub-sub/types.tsx';

const issueSetParentEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$.ofType(SET_PARENT_OPTIMISTIC).mergeMap((action: SetParentOptimisticAction) => {
		const {
			payload: { issues, parentId },
			meta: { optimistic },
		} = action;

		const changedIssueIds = issues
			.filter((issue) => issue.parentId !== parentId)
			.map((issue) => issue.id);

		if (changedIssueIds.length === 0)
			return Observable.of(setParentSuccess(optimistic.id, changedIssueIds));

		const cardsParentAction = Observable.fromPromise(action.payload.requestPromise);

		const [inlineEditBoardsM1Experiment] = UNSAFE_noExposureExp(
			'jira_inline_edit_boards_m1_experiment',
		);

		return cardsParentAction
			.flatMap(() => {
				if (inlineEditBoardsM1Experiment.get('isEnabled', false)) {
					const isCMPBoard = getIsCMPBoard(store.getState());

					const payload = {
						issueId: issues[0].id,
						parentId,
					};

					// We only want to publish the event if we are on a CMP board since the new Relay inline editable
					// parent field is only available there
					if (isCMPBoard) {
						publishInlineEditingEvent(
							InlineEditingEventTypes.INLINE_EDITING_BOARD_PARENT_UPDATED,
							payload,
						);
					}
				}

				return Observable.of(setParentSuccess(optimistic.id, changedIssueIds));
			})
			.catch((error: FetchError) => {
				log.safeErrorWithoutCustomerData(
					'issue.set-parent.failure',
					'Failed to set issue parent',
					error,
				);
				return Observable.of(
					// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
					setParentFailure(optimistic.id) as Action,
					workRefreshData(REFRESH_SOURCE_FAILURE),
				);
			});
	});

export default issueSetParentEpic;
